
import SubscriberContent from "./SubscriberContent";
import Footer from '../../components/Footer';

const Subscribers: React.FC = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        <div className="main-container-inner">
                            {/* <div className="logo mb-3"><img src="logo-min.png" /></div> */}
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Subscribers</h1>
                                </div>
                                <SubscriberContent />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Subscribers;